import React, { useCallback, useEffect, useRef } from "react";
import VariantTable from "./VariantTable";
import { useDispatch, useSelector } from "react-redux";
import { translate } from "../../Services/translation";
import { Svg } from "../Svg";
import { setVariantTableState } from "../../Actions/VariantTable.action";
import CustomScrollbar from "../CustomScrollBar";

const AccessoriesMobile = ({ showPrices, showQuantityCol }) => {
    /**
     * @type array
     */
    let variants = __litium.variants;
    if (typeof variants === 'undefined' || !variants.length) return null;

    const dispatch = useDispatch();
    const { accessoryOpen, queryParams } = useSelector((state) => state.variantTable);
    const variant = accessoryOpen != null ? variants.find(v => v.id === accessoryOpen) : null;

    const scrollContainerRef = useRef(null);
    const scrollContentRef = useRef(null);

    useEffect(() => {
        document.querySelector('body').style.overflow = (accessoryOpen ? 'hidden' : 'initial');
    }, [accessoryOpen]);

    const closeAccessoriesModal = () => {
        const newParams = { ...queryParams };
        delete newParams['showAccessories'];
        dispatch(setVariantTableState({ accessoryOpen: null, queryParams: newParams }))
    }

    if (!variant) {
        return null;
    }

    return (
        <div className="accessories-modal__inner">
            <div className="accessories-modal__content-container">
                <div className="accessories-modal__content">
                    <div className="row accessories-modal__top">
                        <div className="columns small-9 ps-0">
                            <div className='variant-table__accessories-heading'>
                                <h4>{translate('nmas.product.table.consumablesandaccessories')} {variant.id} – {variant.name}</h4>
                            </div>
                        </div>

                        <div className="columns small-3 text--right pe-0">
                            <button className="accessories-modal__close" type="button" onClick={() => closeAccessoriesModal()}>
                                <Svg icon="close" />
                            </button>
                        </div>
                    </div>

                    <div className="accessories-modal__table-container">
                        <VariantTable
                            variants={variant.accessories}
                            isAccessoryTable={true}
                            hideDefaultScroll={true}
                            scrollContainerRef={scrollContainerRef}
                            scrollContentRef={scrollContentRef}
                        />
                    </div>

                    <CustomScrollbar containerRef={scrollContainerRef} contentRef={scrollContentRef} />
                </div>
            </div>

            <div className="accessories-modal__overlay" onClick={() => closeAccessoriesModal()}></div>
        </div>
    );
}

export default AccessoriesMobile;